"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiHeart = function IconUiHeart(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M33.082 4.03a10.592 10.592 0 0 0-7.746 3.2 2.832 2.832 0 0 0-.295.344A11.363 11.363 0 0 0 24 8.838a11.363 11.363 0 0 0-1.041-1.265 2.832 2.832 0 0 0-.295-.344 10.592 10.592 0 0 0-7.746-3.2A10.921 10.921 0 0 0 3.928 15.02 12.022 12.022 0 0 0 6.4 22.526L24 45.737l17.6-23.2a12.03 12.03 0 0 0 2.477-7.512A10.924 10.924 0 0 0 33.082 4.03zm6.923 17.288L24 42.427 7.991 21.312a9.934 9.934 0 0 1-2.063-6.292 8.921 8.921 0 0 1 8.99-8.99 8.55 8.55 0 0 1 6.332 2.613.973.973 0 0 1 .1.12l.111.138a9.109 9.109 0 0 1 1.639 2.331l.9 1.861.9-1.861A9.109 9.109 0 0 1 26.537 8.9l.111-.138a.973.973 0 0 1 .1-.12 8.55 8.55 0 0 1 6.334-2.612 8.924 8.924 0 0 1 8.99 8.99 9.943 9.943 0 0 1-2.067 6.298z"
  }));
};

IconUiHeart.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiHeart;
exports.default = _default;